{
  "INTEGRATION_APPS": {
    "FETCHING": "Fetching Integrations",
    "NO_HOOK_CONFIGURED": "There are no {integrationId} integrations configured in this account.",
    "HEADER": "Applications",
    "STATUS": {
      "ENABLED": "Enabled",
      "DISABLED": "Disabled"
    },
    "CONFIGURE": "Configure",
    "ADD_BUTTON": "Add a new hook",
    "TEST_CONNECTION": {
      "BUTTON": "Test connection",
      "SUCCESS": "Connection successful",
      "ERROR": "Connection failed. Please check your credentials."
    },
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirm deletion",
        "ACCOUNT": "Disconnect"
      },
      "MESSAGE": {
        "INBOX": "Are you sure to delete?",
        "ACCOUNT": "Are you sure to disconnect?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Yes, Delete",
        "ACCOUNT": "Yes, Disconnect"
      },
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Hook deleted successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "LIST": {
      "FETCHING": "Fetching integration hooks",
      "INBOX": "Inbox",
      "EDIT": {
        "BUTTON_TEXT": "Edit"
      },
      "DELETE": {
        "BUTTON_TEXT": "Delete"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Create",
        "CANCEL": "Cancel"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook added successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Update",
        "CANCEL": "Cancel"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook updated successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connect"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Disconnect"
    },
    "SIDEBAR_DESCRIPTION": {
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Sync emails and webchats to your daktela account.",
      "RETINO": "Retino brings order to returns and claims management.",
      "MAILSHIP": "Mailship is a warehouse and order fulfillment management system. Look up order status, tracking and expedition details.",
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "RAYNET": "Connect your Raynet CRM account to access your customer data. Add a connection with your Raynet username and API token."
    }
  }
}
